import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "@/i18n";

export default function Expertises() {
  const { t } = useTranslation();

  const expertises = [
    {
      code: "01 / SG",
      pole: "sg",
      title: t("expertises.sg.title"),
      description: t("expertises.sg.description"),
      subservices: t("expertises.sg.subs"),
    },
    {
      code: "02 / CC",
      pole: "cc",
      title: t("expertises.cc.title"),
      description: t("expertises.cc.description"),
      subservices: t("expertises.cc.subs"),
    },
    {
      code: "03 / PL",
      pole: "pl",
      title: t("expertises.pl.title"),
      description: t("expertises.pl.description"),
      subservices: t("expertises.pl.subs"),
    },
  ];

  return (
    <section id="expertises" className="relative py-24 sm:py-32 lg:py-40 bg-ink-soft" data-testid="expertises-section">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="label-accent" data-testid="expertises-overline">{t("expertises.overline")}</span>
          <h2 className="mt-6 font-serif font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl leading-tight">
            {t("expertises.h2a")}
            <em className="italic text-gold-gradient not-italic">{t("expertises.h2em")}</em>
            <br className="hidden sm:block" />
            {t("expertises.h2b")}
          </h2>
        </motion.div>

        <div className="mt-20 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {expertises.map((e, i) => (
            <div
              key={e.code}
              className="block"
              data-testid={`expertise-link-${e.pole}`}
            >
            <motion.article
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -6 }}
              className="group relative bg-ink-card border border-white/5 hover:border-gold/40 p-8 sm:p-10 transition-colors duration-500 flex flex-col"
              data-testid={`expertise-card-${i}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-xs tracking-[0.25em] text-gold/70">{e.code}</span>
                <ArrowUpRight className="w-5 h-5 text-[#9BA1B0] group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
              </div>
              <h3 className="mt-10 font-serif text-xl sm:text-2xl leading-snug">{e.title}</h3>
              <p className="mt-4 text-sm text-[#A0A5B1] leading-relaxed flex-1">{e.description}</p>
              <ul className="mt-8 pt-6 border-t border-white/5 space-y-3">
                {e.subservices.map((s) => (
                  <li key={s} className="flex items-center gap-3 text-sm text-[#A0A5B1] group-hover:text-[#FAF8F5] transition-colors duration-300">
                    <span className="w-4 h-px bg-gold/60 shrink-0" />
                    {s}
                  </li>
                ))}
              </ul>
            </motion.article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
